import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { DOCUMENTS_CONTENT } from 'constants/controllers'

export default new Controller({
  name: 'LegacyAutomatedDocumentsRedirect',
  route: 'corporate/documents-automated/list/:sectionId/(:focusedId)', // At the time of the multi AOL we only had corporate documents
  controller (Router, { params }) {
    const target = url(DOCUMENTS_CONTENT, params)
    replaceUrl(target)
  }
})
